export default [
    {
        path: '/all-about-my-days',
        name: 'all-about-my-days',
        meta: { requiresAuth: true },
        component: () => import('@/pages/all-about-my-day/index.vue'),
        beforeEnter: async (to, from, next) => {
            next()
        }
    },
]
